export interface SupportInfoContent {
    heading: string;
    phone: string;
    openingHoursLabel: string;
    openingHours: string;
}

export const customerSupportInfo: SupportInfoContent = {
    heading: "Kundservice",
    phone: "0771 - 17 17 77",
    openingHoursLabel: "Öppettider: Helgfri vardag",
    openingHours: "8.00-18.00",
};
